<template>
  <div
    @dragenter.prevent="toggleActive"
    @dragleave.prevent="toggleActive"
    @dragover.prevent
    @drop.prevent="dropFile"
    :class="{ 'active-dropzone': active }"
    class="dropzone"
  >
    <label for="dropzoneReceipt"
      ><span><img src="../assets/icons/upload.svg" alt="" /></span
      >{{ $t("inputs.selectFile") }}</label
    >
    <input
      type="file"
      id="dropzoneReceipt"
      class="dropzoneFile"
      ref="receiptInput"
      @change="selectedReceipt"
    />
    <span class="dropzone-text">{{ $t("inputs.dragFile") }}</span>
  </div>
</template>
<script>
import { useToast } from "vue-toastification";
export default {
  name: "ReceiptDropZone",
  data() {
    return {
      dropzoneFile: "",
      active: false,
    };
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  methods: {
    toggleActive() {
      this.active = !this.active;
    },
    dropFile(e) {
      this.dropzoneFile = e.dataTransfer.files[0];
      this.$emit("dropReceipt", this.dropzoneFile);
    },
    selectedReceipt() {
      // Get the selected file
      const selectedFile = this.$refs.receiptInput.files[0];

      // Check if a file is selected
      if (selectedFile) {
        // Check if the selected file is an image
        if (selectedFile.type.startsWith('image/')) {
          // If it's an image, emit the event
          this.$emit("selectReceipt", selectedFile);
        } else {
          // If it's not an image, you can handle the error or notify the user
          this.toast.error(this.$t('pleaseImg'));
          // Alternatively, you can notify the user through a UI element or any other method.
        }
      } else {
        // this.toast.warning(`No file selected.`);
        // Handle the case where no file is selected
        // Alternatively, you can notify the user through a UI element or any other method.
      }
    },
  },
};
</script>
